export enum EDialogWidth {
  xl = '1800px',
  large = '1200px',
  medium = '700px',
  small = '600px',
  xSmall = '500px',
}
